import React, { useState, useEffect } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import striptags from "striptags"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb-products"

import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"
import SchemaProduct from "§/src/components/schema/s-product"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Functions
import { isEmpty } from "lodash"
import { sanitize } from "§/src/utils/functions"
import UniversalLink from "§/src/utils/UniversalLink"
import { lazyIframeModal } from "§/src/utils/lazyIframeModal";
import { configuratorLink } from "§/src/utils/configuratorLink";

// Components
const Gallery = React.lazy(() => import("§/src/components/sections/gallery/index.js"))
const GalleryZoom = React.lazy(() => import("§/src/components/sections/gallery/index-zoom.js"))

const AccordionProduct = React.lazy(() =>
  import("§/src/components/sections/accordion-product")
)
const VideoFull = React.lazy(() =>
  import("§/src/components/sections/video-full")
)
const EditorialBanner = React.lazy(() =>
  import("§/src/components/sections/editorial-banner")
)
const RelatedProducts = React.lazy(() =>
  import("§/src/components/sections/related-products")
)
const CaseHistoryCarousel = React.lazy(() =>
  import("§/src/components/sections/case-history-carousel")
)

const ContactModalProduct = React.lazy(() => import("§/src/components/contact-modal-product"))

// Atoms
import TileProductReplacement from "§/src/components/atoms/content/tile-content-product-mini"
import ProductBadge from "§/src/components/atoms/badge/product-badge"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

// const TileContentWithModal = React.lazy(() => import("§/src/components/atoms/content/tile-content-with-modal"))
const Modal = React.lazy(() => import("§/src/components/atoms/content/modal"))

//
// import TileContentWithModal from "../../components/atoms/content/tile-content-with-modal"
// import Modal from "../../components/atoms/content/modal"

// Internals
import "./_style.scss"

const Resources = React.lazy(() => import("./resources"))

const DlLinks = React.lazy(() => import("./dl-links"))

// Assets
const AppStore = "§/src/images/app/appstore.png"
const GooglePlay = "§/src/images/app/googleplay.png"

// Switch Language
import { useTranslation } from "react-i18next"

// <div className="ratio ratio-16x9 text-center mt-4 mb-4 ">
// 	<iframe className="embed-responsive-item"  src="https://cpq.gefran.com/store/gefran/it/fromcms?productId=68"></iframe>
// </div>

import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.product?.seo || {}
  const { t } = useTranslation()
  const product = props.pageContext.product
  const acf = product.acf

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="pdp"></body>
      <SEO
        seo={seo}
        translations={props?.data?.lang?.translations}
        title={ product.title + ' - ' + acf?.subTitle }
        langReplace='products'
        desc={ acf?.subTitle }
      />
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
      <SchemaProduct product={product} acf={acf} />
    </React.Fragment>
  )
}

const Product = props => {
  const { t } = useTranslation()

  const product = props.pageContext.product ?? {}
  const globalOptions = props.pageContext?.globalOptions
  const domainUrl = props.pageContext?.domainUrl;
  const seo = product.seo || {}
  const acf = product.acf
  const modalid = "modal-" + Math.floor(Math.random() * 99999)
	const dealerFinderLink = globalOptions?.acfoptGlobalOptions?.acfGlobal?.productsOptions?.dealerFinderLink;

  const originalId = acf.originalId

  const [resources, setResources] = useState([])

  function scrollToHash(selector) {
  const header = document.querySelector('#main-nav');
  if (!header) {
    console.error('Header not found');
    return;
  }

  const targetElement = document.querySelector(selector);
  if (!targetElement) {
    console.error(`Element with selector ${selector} not found`);
    return;
  }

  const headerHeight = header.offsetHeight;
  const offsetTop = targetElement.getBoundingClientRect().top;
  window.scrollTo(0, offsetTop - headerHeight);
}

  useEffect(() => {

    if (originalId) {
      fetch(
        `${domainUrl}/wp-json/gfrn/v1/asset/product/${originalId}/`
      )
        .then(response => response.json())
        .then(response => setResources(response || []))
        .catch(e => {
          setResources([])
          console.error(`Error on fetch asset for originalId ${originalId}`)
        })
    } else {
      console.error(`originalId: ${originalId}`)
    }
  }, [props])

  // const breadcrumb = product.title + " " + acf?.subTitle

  // Replace <p> with <li>
  // const mainFeatures = acf.mainFeatures.replace(/<(\/*)p[^>]*>/g, "<$1li>")

  const mainFeaturesStripped = striptags(acf.mainFeatures, ["li", "p"])
  const mainFeatures = mainFeaturesStripped.replace(/<(\/*)p[^>]*>/g, "<$1li>")

  // Disable ctas when product is dismissed
  const enableInfoCta = acf?.badge == "eop" ? false : true

  const enableOtherCtas =
    acf?.badge == "eop" ? false : acf?.badge == "phase_out" ? false : true

  const enableCtas = enableInfoCta || enableOtherCtas

  // APP STORES LINK
  var googlePlayLink = false
  var appstoreLink = false

  if (acf.appsAvailableOn && acf.appsAvailableOn === "nfc") {
    var googlePlayLink = "https://play.google.com/store/apps/details?id=com.gefran.gefrannfc";
    var appstoreLink = "https://apps.apple.com/it/app/gefran-nfc/id1593661958";
    var microsoftLink = null;
  }
  if (acf.appsAvailableOn && acf.appsAvailableOn === "sensormate") {
    var googlePlayLink = "https://play.google.com/store/apps/details?id=ch.Sensormate.Inspectmate&hl=en_US";
    var appstoreLink = "https://apps.apple.com/de/app/sensormate/id1509011013";
    var microsoftLink = "https://apps.microsoft.com/store/detail/sensormate/9NJ60Q0CMBZL";
  }

  // Site Language
  const siteLanguage = process.env.GATSBY_SITE_LANG

  // IO Link
  const ioLinkUrl = siteLanguage === 'it_IT' ? 'https://cpq.gefran.com/store/gefran/it/iolink/search' : 'https://cpq.gefran.com/store/gefran/en/iolink/search'
  const ioLinkResource = acf.ioLink ? ioLinkUrl : false

  // Configurator Link
  const configLink = configuratorLink(acf?.configuratorLink, siteLanguage, originalId)

  // Default Image Alt Tag
  const defAlt = product.title + ' - ' + sanitize(acf?.subTitle)

  function normalizeBreadcrumbsParentUrl(breadcrumbs) {
    if (breadcrumbs.length < 2) {
      return breadcrumbs;
    }

    const lastUrl = breadcrumbs[breadcrumbs.length - 1].url;
    const urlParts = lastUrl.split('/');

    urlParts.pop(); // Remove last part of url
    urlParts.pop();
    const modifiedUrl = urlParts.join('/') + '/';

    breadcrumbs[breadcrumbs.length - 2].url = modifiedUrl;

    return breadcrumbs;
  }

  return (
    <Layout lang={props?.data?.lang?.translations} langReplace='products'>
      <Breadcrumb
        wpseo={normalizeBreadcrumbsParentUrl(props?.pageContext?.product?.seo?.breadcrumbs)}
        className="mb-0"
      />

      {!isEmpty(props) ? (
        <React.Suspense fallback={<LoadingFrame/>}>
          <ContactModalProduct
            modalid={modalid}
            pageTitle={seo.opengraphTitle || ""}
          ></ContactModalProduct>
          <div id="pdp-top" className="row">
            <div className="title-cont d-md-none">
              <h1 className="title">{product.title}</h1>
              {acf?.badge && <ProductBadge data={acf.badge} size="sm" />}
            </div>

            <h2
              className="subtitle h5 mb-4 d-md-none"
              dangerouslySetInnerHTML={{ __html: sanitize(acf?.subTitle) }}
            ></h2>

            <div id="pdp-gallery" className="col-xl-5 col-lg-4 col-md-6">
              {acf?.gallery && (
                acf?.galleryZoom ? (
                  <GalleryZoom
                    data={acf.gallery}
                    defAlt={defAlt}
                    fit="contain"
                    zoom={true}
                  />
                ) : (
                  <Gallery
                    data={acf.gallery}
                    defAlt={defAlt}
                    fit="contain"
                    zoom={false}
                  />
                )
              )}
            </div>

            <div id="pdp-desc" className="col-xl col-lg-5 col-md-6 px-md-5">
              <div className="title-cont d-none d-md-flex">
                <h1 className="title">{product.title}</h1>
                {acf?.badge && <ProductBadge data={acf.badge} size="sm" />}
              </div>

              <h2
                className="subtitle h5 d-none d-md-block"
                dangerouslySetInnerHTML={{ __html: sanitize(acf?.subTitle) }}
              ></h2>

              {mainFeatures?.length > 0 && (
                <div className="features order-2 order-md-1">
                  <span className="title">
                    {t("Caratteristiche principali")}
                  </span>
                  <ul
                    className="list mb-0"
                    dangerouslySetInnerHTML={{
                      __html: sanitize(mainFeatures),
                    }}
                  />
                </div>
              )}

              {enableCtas && (
                <div className="ctas order-1 order-md-2">
                  {enableInfoCta && (
                    <button
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target={`#${modalid}`}
                    >
                      {t("Richiedi informazioni")}
                    </button>
                  )}
                  {enableOtherCtas && configLink && (
                    <React.Fragment>
                      <button
                        className="btn btn-outline-dark config-prod-cta"
                        data-bs-toggle="modal"
                        data-bs-target="#configureProd"
                        onMouseEnter={el => { lazyIframeModal('#configureProd') }}
                        onClick={el => { lazyIframeModal('#configureProd') }}
                      >
                        {t("Configura")}
                      </button>

                      <Modal modalid="configureProd" className="iframeModal">
                        <div className="ratio mt-4 mb-4">
                          <iframe
                            className="embed-responsive-item"
                            data-src={configLink}
                          ></iframe>
                        </div>
                      </Modal>
                    </React.Fragment>
                  )}
                  {(enableOtherCtas && dealerFinderLink) && (
                    <UniversalLink className="dealer-finder" to={dealerFinderLink}>
                      {dealerFinderLink[2] ?? t("Trova un rivenditore vicino a te")}
                    </UniversalLink>
                  )}
                </div>
              )}

              {acf?.replacementProduct && (
                <TileProductReplacement
                  className="replacement order-3"
                  data={acf?.replacementProduct}
                  title={t("Prodotto sostitutivo")}
                />
              )}
            </div>

            <div id="pdp-downloads" className="col-xl-3 col-lg-3 ps-lg-5">
              {resources.length > 0 &&
                <React.Fragment>
                  <span className="title fs-9 mb-3 d-lg-none">
                    {t("Risorse disponibili")}
                  </span>
                  <span className="title fs-9 mb-1 d-none d-lg-flex">
                    {t("Download")}
                  </span>
                  <span className="subtitle d-none d-lg-flex">
                    {t("Risorse disponibili")}
                  </span>
                  <DlLinks resources={resources} ioLinkResource={ioLinkResource} />

                  {acf?.cadenasLink &&
                    <React.Fragment>
                      <span className="title fs-9 d-flex mt-5 mb-2">
                        {t("Modelli CAD/CAE")}
                      </span>
                      <ButtonArrow
                        key="universalLink"
                        dir="top-end"
                        text={t('Download CAD/CAE')}
                        className={"text-black bg-gray"}
                        onClick={() => {
                          function scrollToHash(selector) {
                            const header = document.querySelector('#main-nav');
                            const targetElement = document.querySelector(selector);
                            if (header && targetElement) {
                              const headerHeight = header.offsetHeight;
                              const offsetTop = targetElement.getBoundingClientRect().top;
                              window.scrollTo(0, offsetTop - headerHeight);
                            }
                          }
                          scrollToHash('#cad-cae');
                        }}

                      ></ButtonArrow>
                    </React.Fragment>
                  }
                </React.Fragment>
              }
            </div>
          </div>

          <div id="pdp-bottom" className="bg-full g-100">
            {(acf?.overview || acf?.appsAvailableOn) && (
              <div id="technical-specs" className="row">
                <div className="left col-lg-3">
                  <h3 className="title">{t("Specifiche tecniche")}</h3>
                </div>
                <div className="right col-md-12 offset-lg-1 col-lg-7 col-xl-5">
                  {acf?.overview && (
                    <React.Fragment>
                      <span className="overview">{t("Panoramica")}</span>
                      <div
                        className="content"
                        dangerouslySetInnerHTML={{
                          __html: sanitize(acf?.overview),
                        }}
                      ></div>
                    </React.Fragment>
                  )}

                  {acf?.appsAvailableOn !== "no" &&
                    acf?.appsAvailableOn !== null && (
                      <div className="app">
                        <span>{t("Disponibile su")}</span>

                        <div className="app-buttons">
                          <a href={appstoreLink} target={"_blank"}>
                            <StaticImage
                              src="../../images/app/appstore.png"
                              placeholder="blurred"
                              alt={t("Scarica da Apple Store")}
                            />
                          </a>

                          <a href={googlePlayLink} target={"_blank"}>
                            <StaticImage
                              src="../../images/app/googleplay.png"
                              placeholder="blurred"
                              alt={t("Scarica da Google Play Store")}
                            />
                          </a>

                          {microsoftLink &&
                            <a href={microsoftLink} target={"_blank"}>
                              <StaticImage
                                src="../../images/app/microsoft.png"
                                placeholder="blurred"
                                alt={t("Scarica da Microsoft Store")}
                              />
                            </a>
                          }
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}

            {(acf?.compAccordion || acf?.descriptionAccordionTab) && (
              <AccordionProduct
                data={acf?.compAccordion}
                cadenas={acf?.cadenasLink}
                descriptionTab={acf?.descriptionAccordionTab}
              />
            )}

            {acf?.mainVimeoVideoUrl && (
              <VideoFull
                className="padded"
                data={{
                  type: "with-controls",
                  videoVimeo: acf?.mainVimeoVideoUrl,
                  videoVimeoMobile: acf?.mainVimeoVideoUrl,
                }}
              />
            )}

            <Resources resources={resources} domainUrl={domainUrl} />

            {acf?.compEditorialBanner && (
              <EditorialBanner
                template={acf?.editorialBannerStyle}
                data={acf?.compEditorialBanner}
              />
            )}

            {acf?.relatedApplications && (

              <CaseHistoryCarousel
                className="product-chc"
                data={acf?.relatedApplications}
              />
            )}

            {acf?.relatedProducts && (
              <RelatedProducts
                className="bg-full bg-white"
                data={acf?.relatedProducts}
              />
            )}
          </div>
        </React.Suspense>
      ) : (
        <Error message={"Something Went Wrong"} />
      )}
    </Layout>
  )
}

export default Product

export const pageQuery = graphql`
  query GET_TRANSLATIONS($slug: String!) {
    lang: wpProduct(slug: { eq: $slug }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`
